import {useState, useCallback} from "react";
import {useDispatch} from "react-redux";
import {useNavigate} from "react-router-dom";
import {useDisclosure} from "../../../hooks/useDisclosure";
import {
  deleteSensorAlertData,
  toggleSensorAlertState,
} from "../../../redux/Actions/alerts.actions";
import {filterScopeBySitesAndLocations} from "../../../utils/filterScope";
import {useFetchSensorAlerts} from "./useSensorAlertTableData";

export const useSensorAlertTableActions = (fetchAfterDelete = () => {}) => {
  const {
    isOpen: isDeleteModalOpen,
    onClose: closeDeleteModal,
    onOpen: openDeleteModal,
  } = useDisclosure();
  const {
    isOpen: isEditModalOpen,
    onClose: closeEditModal,
    onOpen: openEditModal,
  } = useDisclosure();
  const {
    isOpen: isHandoffModalOpen,
    onClose: closeHandoffModal,
    onOpen: openHandoffModal,
  } = useDisclosure();
  const dispatch = useDispatch();
  const {refetch} = useFetchSensorAlerts();
  const navigate = useNavigate();
  const [selectedRow, setSelectedRow] = useState(null);

  const clearSelectedRow = () => {
    setSelectedRow(null);
  };

  const handleActionSelection = useCallback(
    (action, data) => {
      setSelectedRow({
        ...data,
        scope: filterScopeBySitesAndLocations(data.scope, data.sites, data.locations),
      });
      switch (action) {
        case "Edit":
          openEditModal();
          break;
        case "History":
          navigate(`/app/sensor-alert-history/${data.id}`);
          break;
        case "Handoff":
          openHandoffModal();
          break;
        case "Delete":
          openDeleteModal();
          break;
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const handleDelete = () => {
    const callback = () => {
      closeDeleteModal();
      clearSelectedRow();
      fetchAfterDelete();
    };
    dispatch(deleteSensorAlertData(selectedRow.id, callback));
  };

  const handleDeleteModalClose = () => {
    closeDeleteModal();
    clearSelectedRow();
  };

  const handleEditModalClose = () => {
    closeEditModal();
    clearSelectedRow();
  };

  const handleHandoffModalClose = () => {
    closeHandoffModal();
    clearSelectedRow();
  };

  const handleToggle = (data) => {
    dispatch(
      toggleSensorAlertState(
        {
          id: data.id,
          requestData: {enabled: !data.enabled},
        },
        refetch
      )
    );
  };

  return {
    closeDeleteModal: handleDeleteModalClose,
    closeEditModal: handleEditModalClose,
    closeHandoffModal: handleHandoffModalClose,
    handleActionSelection,
    handleDelete,
    handleToggle,
    isDeleteModalOpen,
    isEditModalOpen,
    isHandoffModalOpen,
    selectedRow,
  };
};
